import { FormInstance } from "domain/entities/form-instance";
import { FormQuestion } from "domain/entities/form-question";
import { FormQuestionOptions } from "domain/entities/form-question-options";
import { FormTemplate } from "domain/entities/form-template";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

type FormData = {
    formTemplate: FormTemplate;
    currentQuestionOrder: number;
    totalQuestions: number;
    questions: FormQuestion[];
    questionOptions: FormQuestionOptions[];
    deletedQuestionIds: string[];
    addedQuestions: string[];
    instance: FormInstance;
}
interface UseFormsEditState {
    formData: FormData;
    setFormsEdit: (newFormData: Partial<FormData> | undefined) => void;
    resetFormsData: () => void;
}

const getInitialFormsData = (): FormData => ({
    currentQuestionOrder: 0,
    totalQuestions: 0,
    questions: [],
    questionOptions: [],
    deletedQuestionIds: [],
    formTemplate: {
        id: "",
        title: "",
        description: "",
        config: "",
        active: false,
        createdAt: new Date(),
        modifiedAt: null
    },
    instance: {
        id: "",
        active: false,
        templateId: "",
        slug: "",
        title: "",
        description: "",
        logo: "",
        isAnonymous: false,
        questionPerPage: 1
    },
    addedQuestions: []
})
export const useFormsEditStore = create<UseFormsEditState>()(
    devtools(
        (set) => ({
            formData: getInitialFormsData(),
            setFormsEdit: (newFormData) =>
                set((state) => ({
                    formData: {...state.formData, ...newFormData}
            })),
            resetFormsData: () => {
                set({formData: getInitialFormsData()});
            }
            
        })
    )
);